module.exports = __webpack_public_path__ + "images/b935b78940027037020ed8c198a3a0a9-staying-pic-meghalaya.png";